import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PingPongIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M12.6927 5.77485C12.728 5.95704 12.6642 6.1427 12.533 6.27391L6.82342 11.9835C6.40697 10.8269 5.30006 10 4 10C3.35363 10 2.75501 10.2044 2.26525 10.5521C0.435957 8.23635 0.590251 4.86602 2.72813 2.72814C5.03232 0.423955 8.76813 0.423955 11.0723 2.72814C11.9368 3.5926 12.4769 4.65857 12.6927 5.77485Z"
		></path>
		<path
			fill="currentColor"
			d="M2.95945 11.2917C3.2626 11.1066 3.61885 11 4 11C5.00004 11 5.82864 11.734 5.97652 12.6926C5.99198 12.7928 6 12.8955 6 13C6 14.1046 5.10457 15 4 15C2.89543 15 2 14.1046 2 13C2 12.2766 2.38408 11.6429 2.95945 11.2917Z"
		></path>
		<path
			fill="currentColor"
			d="M12.2876 9.31005C12.0586 9.82241 12.1085 10.4396 12.5053 10.8365L14.8272 13.1584C15.0576 13.3888 15.0576 13.7624 14.8272 13.9928L13.9928 14.8272C13.7624 15.0576 13.3888 15.0576 13.1584 14.8272L10.8365 12.5053C10.4396 12.1085 9.82241 12.0586 9.31005 12.2876C8.82845 12.5029 8.52456 11.9512 8.89758 11.5782L11.5782 8.89759C11.9512 8.52456 12.5029 8.82845 12.2876 9.31005Z"
		></path>
	</svg>
))
